import React, { Component, Fragment } from "react";
import { findAuthorizedId } from "../../../domain/validation/utils";
import { FormattedMessage, defineMessages } from "react-intl";
import { ERRORS, REQUIRED } from "../../../constants/FormMessages";
import isEmpty from "assets/scripts/utils/isEmpty";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "assets/scripts/components/common/form/Form/Form";
import { default as DecedentRelationshipFormGroup } from "assets/scripts/components/common/form/DecedentRelationshipFormGroup/DecedentRelationshipFormGroup";
import CheckboxFormGroup from "assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup";
import ValidationFieldset from "assets/scripts/components/common/form/ValidtationFieldset/ValidationFieldset";
const messages = defineMessages({
    submit: {
        id: "forms.accountAddValidation.submit",
        defaultMessage: "OK"
    },
    authorizedLabel: {
        id: "forms.accountAddValidation.authorized.label",
        defaultMessage: "I am the person, or I am representing the person who is authorized to act on behalf of the estate."
    }
});
function showAuthorizedAndRelationship(deceased) {
    return deceased;
}
function getErrors(value, deceased, customFields) {
    const validation = {};
    for (const { id } of customFields) {
        if (isEmpty(value.validation[id])) {
            validation[id] = REQUIRED;
        }
    }
    const checkAuthorizedAndRelationship = showAuthorizedAndRelationship(deceased);
    return {
        authorized: checkAuthorizedAndRelationship && !value.authorized ? REQUIRED : null,
        relationship: checkAuthorizedAndRelationship && value.relationship === "" ? ERRORS.SELECT : null,
        validation
    };
}
export default class AccountAddValidationForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleAuthorizedChange = (authorized) => this.setState({ authorized });
        this._handleRelationshipChange = (relationship) => this.setState({ relationship });
        this._handleValidationChange = (validation) => this.setState({ validation });
        const doShowAuthorizedAndRelationship = showAuthorizedAndRelationship(props.deceased);
        this.state = {
            authorized: !doShowAuthorizedAndRelationship,
            relationship: doShowAuthorizedAndRelationship ? "" : "Self",
            validation: {}
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const { validation: validationErrors, ...errors } = getErrors(value, props.deceased, props.customFields);
        const isValid = Object.values(errors).every(it => it == null)
            && Object.values(validationErrors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.accountAddValidation.legend" defaultMessage="Validation Information"/>
						</span>
					</legend>

					{showAuthorizedAndRelationship(props.deceased) && (<Fragment>
							<CheckboxFormGroup name="authorized" label={messages.authorizedLabel} value={value.authorized} onChange={this._handleAuthorizedChange} error={errors.authorized} backendError={backendErrors.attestation} required/>
							<DecedentRelationshipFormGroup name="relationship" value={value.relationship} onChange={this._handleRelationshipChange} error={errors.relationship} backendError={backendErrors.decedentRelationship} required/>
						</Fragment>)}

					<ValidationFieldset requirements={props.customFields} locale={props.locale} value={value.validation} onChange={this._handleValidationChange} errors={validationErrors}/>
				</fieldset>
			</Form>);
    }
    _handleSubmit() {
        const { referenceNumber, pin } = this.props.validation;
        const value = {
            ...this.state,
            referenceNumber,
            pin,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            email: "",
            relationship: this.state.relationship // assert type
        };
        this.props.startValidation(value);
        const authId = findAuthorizedId(value.firstName, value.lastName, this.props.authIndividuals);
        if (authId) {
            this.props.setAuthId(authId);
            this.props.sendValidation(value, authId);
            this.props.closeModal({ modalId: "validateAddAccount", triggerId: "" });
        }
        else {
            this.props.openModal({ modalId: "authIndividualAdd", triggerId: "" });
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/AccountAddValidationForm.tsx